import React from "react";
import PropTypes from "prop-types";
import OneCol, { Row } from "layouts/OneCol";
import Header from "components/views/Header";
import T from "i18n";
import PageHeading from "components/views/atoms/PageHeading";
import ProgressHeading from "components/views/ProgressHeading";
import EndOfPageNotes from "components/views/EndOfPageNotes";
import OutlinedMoreHelp from "components/views/OutlinedMoreHelp";
import OutlinedLinksGrid from "components/views/OutlinedLinksGrid";
import TypeSelector from "components/views/SearchTypeSelector";

import Footer from "components/views/atoms/Footer";

const SearchTypeSelector = ({ className, breadcrumbs }) => {
  const classes = ["SearchTypeSelector"];
  if (className) classes.push(className);
  const bc = breadcrumbs.map((b) => b());

  return (
    <OneCol className={classes.join(" ")}>
      <Header heading="Commercial" />
      <PageHeading>
        <T path="common.productSelector" />
      </PageHeading>

      <Row fullWidth>
        <ProgressHeading
          perc={40}
          heading={T({ path: "searchTypeSelectorPage.progressHeading" })}
          breadcrumbSteps={bc}
        />
      </Row>

      <Row>
        <TypeSelector />
      </Row>

      <Row>
        <OutlinedLinksGrid>
          <OutlinedMoreHelp LinkLabel={T({ path: "button.moreHelpUrl" })} />
        </OutlinedLinksGrid>
      </Row>

      <Row>
        <EndOfPageNotes />
      </Row>

      <Footer />
    </OneCol>
  );
};

SearchTypeSelector.displayName = "SearchTypeSelector";

SearchTypeSelector.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.func),
};

SearchTypeSelector.defaultProps = {
  className: null,
  breadcrumbs: [],
};

export default SearchTypeSelector;
